import { preselectBudgetAllocationChannel } from '@/features/reports'

/** `routes.ts` — the retired explorer route names, and the Budget Allocation channel each maps to. */
const RETIRED_EXPLORER_CHANNELS: Readonly<Record<string, string>> = Object.freeze({
  MetaAdAnalysis: 'Meta',
  TiktokAnalyses: 'Tiktok',
})

export type NavResetRegister = (
  reset: (to: { redirectedFrom?: { name?: unknown } | undefined }) => void,
) => void

export function registerMarketingInsightsNavResets(register: NavResetRegister): void {
  register((to) => {
    // `redirectedFrom` is the only place a redirect's origin survives — by the time the navigation
    // is confirmed, `to` is Budget Allocation and `from` is wherever the visitor was before.
    const origin = to.redirectedFrom?.name
    if (typeof origin !== 'string') return
    const channel = RETIRED_EXPLORER_CHANNELS[origin]
    if (channel === undefined) return
    preselectBudgetAllocationChannel(channel)
  })
}
